import { makeStyles } from '@material-ui/core/styles'
import COLORS from '../../utils/constants/colors'

export const maintenancePageStyles = makeStyles((theme) => ({
  container: {
    minHeight: '100vh',
    width: '100vw',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: `linear-gradient(135deg, ${COLORS.purple}60 0%, ${COLORS.lightOrange} 100%)`,
    padding: theme.spacing(4),
    margin: 0,
    maxWidth: 'none',
  },
  content: {
    textAlign: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    borderRadius: theme.spacing(3),
    padding: theme.spacing(8, 6),
    boxShadow: '0 20px 60px rgba(0,0,0,0.08), 0 8px 25px rgba(0,0,0,0.12)',
    border: 'none',
    backdropFilter: 'blur(20px)',
    maxWidth: 520,
    margin: '0 auto',
    position: 'relative',
    overflow: 'hidden',
  },
  iconContainer: {
    marginBottom: theme.spacing(5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  title: {
    fontWeight: 600,
    color: COLORS.lightBlack,
    marginBottom: theme.spacing(2),
    letterSpacing: '-0.02em',
  },
  messageContainer: {
    marginBottom: theme.spacing(5),
    '& > *': {
      marginBottom: theme.spacing(2),
    },
  },
  message: {
    color: COLORS.menuChoiceGrey,
    lineHeight: 1.7,
    fontSize: '1rem',
    maxWidth: 400,
    margin: '0 auto',
  },
  footer: {
    borderTop: `1px solid ${COLORS.borderGrey}`,
    paddingTop: theme.spacing(4),
    marginTop: theme.spacing(4),
  },
  footerText: {
    color: COLORS.grey,
    fontSize: '0.8rem',
    opacity: 0.8,
  },
}))
